// 후기 액션(rpc) — 현장 상세의 후기 숨기기·삭제.
import { rpc } from "@/api/client";

export const setReviewHidden = (input: unknown) => rpc("review/actions/setReviewHidden", input);

export const deleteReview = (input: unknown) => rpc("review/actions/deleteReview", input);
